// extracted by mini-css-extract-plugin
module.exports = {"buttonCard":"ButtonCard-module__buttonCard___DHYtr","card":"ButtonCard-module__card___1NJYP"};